/**
 *@author chenli
 *多选内置字段选择器
 * 20180814
 */
import Component from "../../../lib/component";
import {HTTP} from "../../../lib/http";
import {PMAPI, PMENUM} from "../../../lib/postmsg";
import Mediator from "../../../lib/mediator";
import './buildChooseMulti.scss';
import template from './buildChooseMulti.html';
import '../../../lib/fontsize';
import DataTableAgGrid from '../../dataGrid/data-table-page/data-table-agGrid/data-table-agGrid';
import {FormService} from "../../../services/formService/formService";

let BuildChooseMulti = Component.extend({
    template: template,
    data:{
        selected:[],
        sourceFieldDfield:'',
    },
    binds:[
        {
            event:'click',
            selector:'.confirm',
            callback:function () {
                let _this = this;
                _this.data.selected = [];
                let selectedRows = this.data.dataGrid.agGrid.gridOptions.api.getSelectedRows();
                let isError = this.data.dataGrid.data.BuildChooseMultiError;
                selectedRows.forEach((item)=>{
                    _this.data.selected.push(item['_id']);
                })
                PMAPI.sendToParent({
                    type: PMENUM.close_dialog,
                    key: _this.data.key,
                    data: {selected:_this.data.selected,isError:isError},
                });
            }
        }
    ],
    actions:{
        _init:function (data,sourceFieldDfield) {
            let config = {
                tableId: this.data.source_table_id,
                parentTableId: this.data.tableId,
                // base_buildin_dfield: data.dfield,
                source_field_dfield: sourceFieldDfield,
                viewMode: 'viewFromBuildChooseMulti',
                check_total:data.value.length || 0,
                valueBuildMulti:data.value || [],
                btnType: 'none',
                isInitBuildChooseMulti:true
            }
            this.data.dataGrid && this.data.dataGrid._destroy();
            let dataGrid = new DataTableAgGrid({data: config});
            this.data.dataGrid = dataGrid;
            this.append(dataGrid, this.el.find('.choose-wrap'));
            this.hideLoading();
        },
        _getIframeParams: function () {
            PMAPI.getIframeParams(window.config.key).then(res => {
                this.data.dfield = res.data.dfield;
                this.actions._getSourceFieldDfield(res);
            });
            HTTP.flush();
        },
        _getSourceFieldDfield:async function (res) {
            let rowLists = await FormService.getColumnList(this.data.tableId)
            let sourceFieldDfield = '';
            rowLists.rows.forEach((item)=>{
                if(item.base_buildin_dfield == this.data.dfield) {
                    sourceFieldDfield = item.source_field_dfield
                }
            })
            this.actions._init(res.data,sourceFieldDfield);
        }

    },
    async afterRender() {
        this.actions._getIframeParams();
    },
    firstAfterRender:function () {
    }
});
export  default BuildChooseMulti


// WEBPACK FOOTER //
// app/components/popup/bulidChooseMulti/buildChooseMulti.js